import { render, staticRenderFns } from "./ComboStage.vue?vue&type=template&id=36e4390c&scoped=true"
import script from "./ComboStage.vue?vue&type=script&lang=js"
export * from "./ComboStage.vue?vue&type=script&lang=js"
import style0 from "./ComboStage.vue?vue&type=style&index=0&id=36e4390c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e4390c",
  null
  
)

export default component.exports